import React from "react";
import classNames from "classnames";
import { ArrowCornerIcon, DetachIcon, MatchedIcon } from "@icons";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { TransferPairData } from "./transferPairHelpers";
import { PairedTransferTransaction } from "./PairedTransferTransaction";
import styles from "./HistoryPairedTransferDetails.module.scss";

interface PairedTransferCardProps {
    pair: TransferPairData;
    isMatched?: boolean;
    isSelected?: boolean;
    onSelect?: () => void;
    onOpen?: () => void;
}

export const PairedTransferCard: React.FC<PairedTransferCardProps> = ({
    pair,
    isMatched,
    isSelected,
    onSelect,
    onOpen,
}) => {
    const { transaction, pairedTransaction } = pair;

    const icon = isMatched ? (
        <MatchedIcon className={styles.transferIcon} />
    ) : (
        <DetachIcon className={styles.transferIcon} />
    );
    return (
        <div
            className={classNames(styles.pairCard, {
                [styles.pairCardSelected]: isSelected,
            })}
            onClick={onSelect}
            role="button"
            tabIndex={0}
        >
            <div
                className={styles.checkboxColumn}
                onClick={(e) => e.stopPropagation()}
            >
                <Checkbox checked={!!isSelected} onCheckedChange={onSelect} />
            </div>
            <div className={styles.transactionsPair}>
                <div className={styles.transactionRow}>
                    <PairedTransferTransaction transaction={transaction} />
                </div>
                <div className={styles.transferIconContainer}>
                    <div className={styles.transferIconWrapper}>{icon}</div>
                </div>
                <div className={styles.transactionRow}>
                    <PairedTransferTransaction
                        transaction={pairedTransaction}
                    />
                </div>
            </div>
            <button
                className={styles.openPairButton}
                onClick={(e) => {
                    e.stopPropagation();
                    onOpen?.();
                }}
                title="View details"
            >
                <ArrowCornerIcon className={styles.openPairIcon} />
            </button>
        </div>
    );
};
